import { isEmpty } from 'lodash';
/**
 * Retrieves and parses a value from local storage using the provided key.
 * Returns the parsed value from local storage, or null if parsing fails.
 */
export const getLocalStorageParsedValue = (localStorageKey: string): Record<string, unknown> => {
  try {
    return JSON.parse(localStorage.getItem(localStorageKey)) as Record<string, unknown>;
  } catch (error) {
    return null;
  }
};

/**
 * Creates a key in local storage
 * Sets the values as a stringified object
 */
export const setLocalStorageParsedValue = (
  localStorageKey: string,
  localStorageValue: Record<string, unknown>
): void => {
  const storedValue = getLocalStorageParsedValue(localStorageKey);
  if (!!storedValue) {
    const updatedLocalStoredValue = { ...storedValue, ...localStorageValue };
    localStorage.setItem(localStorageKey, JSON.stringify(updatedLocalStoredValue));
  } else {
    localStorage.setItem(localStorageKey, JSON.stringify(localStorageValue));
  }
};

/**
 * Removes attributes from a local storage key
 * If the key has no attributes, this function removes the key
 */
export const removeOrUpdateLocalStorageValue = (localStorageKey: string, attributeToRemove: string): void => {
  const storedValue = getLocalStorageParsedValue(localStorageKey);
  if (!!storedValue) {
    delete storedValue[attributeToRemove];
    if (isEmpty(storedValue)) localStorage.removeItem(localStorageKey);
    else setLocalStorageParsedValue(localStorageKey, storedValue);
  }
};

export const setOrReplaceLocalStorageItem = (
  localStorageKey: string,
  localStorageValue: Record<string, unknown> | string
): void => {
  if (typeof localStorageValue !== 'string') {
    localStorage.setItem(localStorageKey, JSON.stringify(localStorageValue));
  } else {
    localStorage.setItem(localStorageKey, localStorageValue);
  }
};

export const removeLocalStorageItem = (localStorageKey: string): void => {
  localStorage.removeItem(localStorageKey);
};
